import { FC, ReactNode } from 'react'
import { Control, Controller, UseControllerProps } from 'react-hook-form'

import { FormField, Input, InputProps } from '@cloudscape-design/components'

interface FormInputProps {
    label: string
    name: string
    control: Control<any>
    placeholder?: string
    description?: string
    info?: ReactNode
    constraintText?: string
    rules?: UseControllerProps['rules']
    type?: InputProps.Type
    disabled?: boolean
    errorText?: string
    value?: string
    setFormValues: (name: string, value: any) => void
}

const FormInput: FC<FormInputProps> = ({
    label,
    name,
    control,
    placeholder,
    description,
    info,
    constraintText,
    rules,
    type,
    value,
    disabled = false,
    errorText,
    setFormValues
}) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { name, onChange, value }, fieldState: { error } }) => {
                return (
                    <FormField
                        label={label}
                        description={description}
                        info={info}
                        constraintText={constraintText}
                        errorText={errorText ?? error?.message}
                    >
                        <Input
                            name={name}
                            value={value}
                            type={type}
                            placeholder={placeholder}
                            onChange={({ detail }) => {
                                onChange(detail.value)
                                setFormValues(name, detail.value)
                            }}
                            disabled={disabled}
                        />
                    </FormField>
                )
            }}
        />
    )
}
 
export default FormInput
